import { Api } from '@/services/Api';

export default {
  getPageSecurity(body) {
    return Api().post(`/SecurityPage/GetSecurityPages`, body);
  },
  savePageSecurity(body) {
    return Api().post(`/SecurityPage`, body);
  },
}